import React from 'react';
import { ExpenseData } from '@/interface/entityInterface';
import { sheet } from '@/interface/dataInterface';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table"
import CommonDetailsDialog from '@/components/common/details/DetailsDialog';
import Header from '../components/Header';


interface ExpenseDetailsSheetProps extends sheet {
  expense: ExpenseData | null;
}

export const ExpenseDetails: React.FC<ExpenseDetailsSheetProps> = ({
  expense,
  open,
  setOpen,
}) => {
  if (!expense) return null;

  const totalAmount = expense.expense_type_values.reduce(
    (sum, item) => sum + item.value,
    0
  );

  return (
    <CommonDetailsDialog open={open} setOpen={setOpen} title='Expense details' description={`Total breakdown of expense # ${expense.id}`}>
        <div className="w-full max-w-2xl mx-auto bg-background shadow-md overflow-hidden sm:rounded-lg">
      <div className="px-6 py-4 space-y-6">
        <Header date={expense.date} odometer={expense.odometer} vehicle={expense.vehicle} />
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead className='text-right'>Price</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {expense.expense_type_values.map(item => (
              <TableRow key={item.id}>
                <TableCell>{item.expenses_type.name}</TableCell>
                <TableCell className='text-right'>${item.value}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>Total</TableCell>
              <TableCell className='text-right font-bold'>${totalAmount}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <div>
          {expense.notes}
        </div>
      </div>
    </div>
    </CommonDetailsDialog>
  );
};